import { ScrollArea } from "@mantine/core";
import { SectionDivider } from "src/styled";
import { Section } from "src/styled/UserForm.styled";

interface Props {
  title: string;
  children: React.ReactNode | React.ReactNode[];
}
const GenericLoginsSectionWrapper = ({ title, children }: Props) => {
  return (
    <Section style={{ minWidth: "300px", maxWidth: "600px" }}>
      <SectionDivider mr="auto" mb={15}>
        {title}
      </SectionDivider>
      <ScrollArea w="100%" h={500}>
        {children}
      </ScrollArea>
    </Section>
  );
};
export default GenericLoginsSectionWrapper;
